import { Component, DestroyRef, inject, OnInit, signal, ViewChild } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { StateService } from './shared/services/state-service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Drawer } from "./shared/components/drawer/drawer";
import { DrawerService } from './shared/services/drawer-service';
import { DialogBox } from './shared/components/dialog-box/dialog-box';
import { Table } from "./shared/components/table/table";
import { Toast } from "./shared/components/toast/toast";
import { NavigationLoaderService } from './shared/services/navigation-loader-service';
import { Sidebarservice } from './shared/services/sidebarservice';
import { IMenuItems } from './shared/model/menuItems';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Drawer, DialogBox, Toast],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected readonly title = signal('pexlens');

  private stateService = inject(StateService);
  private destroyRef = inject(DestroyRef);

  private router = inject(Router);
  private navigationLoader = inject(NavigationLoaderService);
  private destroyRef1 = inject(DestroyRef)
  private sidebarService = inject(Sidebarservice)

  isLoggedIn: boolean = false;

  constructor() {
  }

  ngOnInit(): void {
    this.isLoggedIn = this.isUserLoggedIn();
    this.setLoaderAndActiveMenu();
  }

  ngAfterViewInit() {
  }

  handleButtonClick(): void {
  }

  isUserLoggedIn(): boolean {
    this.stateService.userLoggedIn$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(isLoggedIn => {
      this.isLoggedIn = isLoggedIn;
    });
    return this.stateService.getUserLoggedIn();
  }

  setLoaderAndActiveMenu() {
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef1)).subscribe(event => {
    const menuItems = this.sidebarService.getmenuItems();

      if (event instanceof NavigationStart) {
        this.navigationLoader.loading.set(true);
      }

      if (event instanceof NavigationEnd) {
        this.updateActiveMenu(menuItems);
        this.navigationLoader.loading.set(false);
      }
      if (
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.navigationLoader.loading.set(false);
      }
    });
  }

  updateActiveMenu(menuItems:IMenuItems[]) {
    const menu = menuItems.find(item =>
      this.router.isActive(item.route, {
        paths: 'subset',
        queryParams: 'ignored',
        fragment: 'ignored',
        matrixParams: 'ignored'
      })
    );
    this.sidebarService.activeMenu.set(menu ?? null)
  }
}
